import { createModel } from '@rematch/core';
import { RootModel } from '../root';
import reducers from './application.reducers';
import effects from './application.effects';
import { ApplicationState } from './application.model';

const initialState: ApplicationState = {
  bffVersion: '',
  adapterVersion: '',
  sigmaAvailable: true,
  eodState: { date: '', status: null },
  kisaLoginPageVisibility: null,
  chatBeforeLoginEnabled: null,
  contactDetailsFeatureToggle: null,
  contractDetailsFeatureToggle: null,
  contractDashboardFeatureToggle: null,
  consentsAndObligationsFeatureToggle: null,
  toggleLoading: true,
  clientSynchroToggle: null,
  htmlContent: [],
  payments: { paymentsAvailability: null },
  dataSynchronized: null
};

const applicationModel = createModel<RootModel>()({
  state: initialState,
  reducers,
  effects
});

export default applicationModel;
